// test1574
(1574 && 0);
